import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Loader from '@ublend-npm/aulaui-next-web/Loader';

import Dialog, {
  DialogTitle,
  DialogContent,
  DialogActions,
} from '../../common/Dialog';

const RemoveParticipantDialog = ({
  userId,
  fullName,
  isRemovingUser,
  isRemoveModalOpen,
  handleCloseRemoveModal,
  handleRemoveParticipant,
}) => {
  let DialogBody = () => (
    <Fragment>
      <DialogContent style={{ padding: '20px 24px' }}>
        Remove {fullName} from this space?
      </DialogContent>
      <DialogActions
        primary={{
          label: 'Remove',
          onClick: () => handleRemoveParticipant(userId),
          textButton: true,
          htmlAttributes: {
            'aria-label': 'Confirm removing user',
            'data-testid': 'confirm-remove-button',
          },
        }}
        secondary={{
          label: 'Cancel',
          onClick: handleCloseRemoveModal,
          textButton: true,
          htmlAttributes: {
            'aria-label': 'Cancel removing user',
            'data-testid': 'cancel-removing-button',
          },
        }}
      />
    </Fragment>
  );

  // fallback screen for when user is not found
  if (!fullName) {
    DialogBody = () => (
      <Fragment>
        <DialogTitle onClose={handleCloseRemoveModal}>
          User not found!
        </DialogTitle>
        <DialogContent style={{ padding: '0 20px 24px' }}>
          <p>
            The selected user might have already been removed from the space.
          </p>
          <p>Please refresh the page and try again.</p>
        </DialogContent>
      </Fragment>
    );
  }

  if (isRemovingUser) {
    DialogBody = () => (
      <Fragment>
        <DialogContent style={{ padding: '0 20px 24px', textAlign: 'center' }}>
          <p>Removing user, please wait...</p>
          <Loader size={25} />
        </DialogContent>
      </Fragment>
    );
  }

  return (
    <Dialog
      id="remove-participant-dialog"
      data-testid="remove-participant-dialog"
      open={isRemoveModalOpen}
      maxWidth="xs"
    >
      <DialogBody />
    </Dialog>
  );
};

RemoveParticipantDialog.propTypes = {
  userId: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  isRemovingUser: PropTypes.bool.isRequired,
  isRemoveModalOpen: PropTypes.bool.isRequired,
  handleCloseRemoveModal: PropTypes.func.isRequired,
  handleRemoveParticipant: PropTypes.func.isRequired,
};

export default RemoveParticipantDialog;
